import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../helpers/visibility'

export default class extends Controller {
  static targets = ["checkbox", "sampleIdField", "bulkUpdateControls"]

  connect() {
    this.update()
  }

  update() {
    if(this.hasSampleIdFieldTarget) {
      const checked = this.checkboxTargets.filter(c => c.checked)
      const sampleIds = checked.map(checkbox => checkbox.value)
      this.sampleIdFieldTargets.forEach(target => {
        target.value = sampleIds.join(",")
      })

      if(sampleIds.length) {
        showTarget(this.bulkUpdateControlsTarget)
      }
      else {
        hideTarget(this.bulkUpdateControlsTarget)
      }
    }
    else {
      this.hideAllCheckboxes()
    }
  }

  hideAllCheckboxes() {
    hideTarget(this.checkboxTargets)
  }
}

